/**
 * Created by EugeneU on 22.10.2015.
 */

export const name: string = 'GIS';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-gis';
export const icon: string = 'asterisk';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-gis';  //VR: Theme ID (to SELECT and EXPAND it in Theme dialog)

//export const priority: number = 1;

